<div class="side_slider_cont">
	<button class="close" (click)="close()">
		<span class=" material-symbols-outlined">close</span>

	</button>
	<div class="upper_slide_cont for_cus_cont">
		<h3>
			<!-- CUSTOM SHIRT SIZE -->
			{{customSizeDataPassOne.profileName}}
		</h3>
		<span class="open_text">
			{{customSizeDataPassOne.disclaimer}}
		</span>
		<!-- <form [formGroup]="dynamicForm" > -->
		<form [formGroup]="dynamicForm">
			<ng-container *ngFor="let controls of fields">
				<p>
					<span>{{controls.label}} <b>{{controls.mandatory?'*':''}}</b></span>
					<span>
						<!-- <input type="text" [type]="controls.fieldType==0?'number':'text'" [formControlName]="controls.label" placeholder="{{controls.placeholder}}"> -->

						<input type="{{controls.fieldType==1?'number':'text'}}" [formControlName]="controls.label" placeholder="{{controls.placeholder}}">
						<!-- <i>{{controls.placeholder}}</i> -->
					</span>
				</p>
			</ng-container>
		</form>
		<p class="error_input" *ngIf="!isFormValid">Please fill up all mandetory(*) fields.</p>
	</div>


	<div class="lower_slide_cont for_cus_cont for_lower">
		<button class="cus_size_button" (click)="onSubmit()">
			continue
		</button>
	</div>
</div>
<div class="overlay_pop_up_pd" (click)="close()"></div>
